import { render, staticRenderFns } from "./TurnChecker.vue?vue&type=template&id=748c2c74&lang=pug&"
import script from "./TurnChecker.vue?vue&type=script&lang=js&"
export * from "./TurnChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports